import React, { useEffect, useMemo, useState } from 'react';
import moment from 'moment';
import { useGetHolidaysQuery } from '../../../redux/apis/holidayApi';

import './UpcomingHolidays.scss';

const UpcomingHolidays = ({ onViewAll, holidays: holidaysProp }) => {
  const { data, isLoading, isFetching } = useGetHolidaysQuery({
    limit: 100
  });

  const [filteredHolidays, setFilteredHolidays] = useState([]);
  const [index, setIndex] = useState(0);

  const holidaysInput = useMemo(() => {
    if (Array.isArray(holidaysProp)) return holidaysProp;
    return data?.data || [];
  }, [data, holidaysProp]);

  useEffect(() => {
    const today = moment();

    const list = (holidaysInput || [])
      .filter((h) => h.isActive !== false)
      .filter((h) => moment(h.date).isSameOrAfter(today, 'day'))
      .sort((a, b) => a.date - b.date);

    setFilteredHolidays(list);
    setIndex(0);
  }, [holidaysInput]);

  const nextSlide = () => {
    if (index < filteredHolidays.length - 1) {
      setIndex(index + 1);
    }
  };

  const prevSlide = () => {
    if (index > 0) {
      setIndex(index - 1);
    }
  };

  const holiday = filteredHolidays[index];
  const busy = !Array.isArray(holidaysProp) && (isLoading || isFetching);
  const showSlider = !busy && filteredHolidays.length > 1;

  return (
    <div className="upcoming-holiday-banner border-0">
      <div className="upcoming-holiday-banner__inner">
        <div className="upcoming-holiday-banner__content">
          <h6 className="upcoming-holiday-banner__title">Upcoming Holidays</h6>

          {busy ? (
            <div className="upcoming-holiday-banner__loading">
              <div className="spinner-border spinner-border-sm text-white" role="status">
                <span className="visually-hidden">Loading holidays</span>
              </div>
            </div>
          ) : holiday ? (
            <div
              key={index}
              className="upcoming-holiday-banner__detail upcoming-holiday-banner__detail--slide"
            >
              <span className="upcoming-holiday-banner__cal" aria-hidden>
                <i className="icofont icofont-ui-calendar" />
              </span>
              <div className="upcoming-holiday-banner__text">
                <span className="upcoming-holiday-banner__name">{holiday.name}</span>
                <span className="upcoming-holiday-banner__date">
                  {moment(holiday.date).format('ddd DD MMM YYYY')}
                </span>
              </div>
            </div>
          ) : (
            <div className="upcoming-holiday-banner__detail">
              <span
                className="upcoming-holiday-banner__cal upcoming-holiday-banner__cal--muted"
                aria-hidden
              >
                <i className="icofont icofont-ui-calendar" />
              </span>
              <div className="upcoming-holiday-banner__text">
                <span className="upcoming-holiday-banner__name">No upcoming holidays</span>
              </div>
            </div>
          )}
        </div>

        {!busy && filteredHolidays.length > 0 ? (
          <div className="upcoming-holiday-banner__actions">
            {showSlider ? (
              <div className="upcoming-holiday-banner__nav">
                <button
                  type="button"
                  className="upcoming-holiday-banner__nav-btn"
                  onClick={prevSlide}
                  disabled={index === 0}
                  aria-label="Previous holiday"
                >
                  <i className="icofont icofont-rounded-left" aria-hidden />
                </button>
                <button
                  type="button"
                  className="upcoming-holiday-banner__nav-btn"
                  onClick={nextSlide}
                  disabled={index === filteredHolidays.length - 1}
                  aria-label="Next holiday"
                >
                  <i className="icofont icofont-rounded-right" aria-hidden />
                </button>
              </div>
            ) : null}
            <button type="button" className="upcoming-holiday-banner__cta" onClick={onViewAll}>
              View All
            </button>
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default UpcomingHolidays;
